import api from './api';
import type { SouthWelcomeRule, SouthWelcomeRulePayload, SouthWelcomeHistoryResponse } from '@/types/southWelcome';

export const southWelcomeRuleService = {
  async getByClient(clientId: number): Promise<SouthWelcomeRule> {
    const result = (await api.get(`/south-welcome-rules/client/${clientId}`)) as any;
    return result?.data ?? result;
  },
  async upsert(clientId: number, payload: SouthWelcomeRulePayload): Promise<SouthWelcomeRule> {
    const result = (await api.put(`/south-welcome-rules/client/${clientId}`, payload)) as any;
    return result?.data ?? result;
  },
  async listHistory(clientId: number, page = 1, limit = 50): Promise<SouthWelcomeHistoryResponse> {
    const result = (await api.get(`/south-welcome-rules/client/${clientId}/historico`, {
      params: { page: String(page), limit: String(limit) },
    })) as any;
    return result;
  },
};
